export function setCookie(cookieName, cookieValue) {
  const a = new Date();
  // set to expire after 30 minutes, or 1.8 million milliseconds
  a.setTime(a.getTime() + 1800000);
  document.cookie = `${cookieName}\x3d${cookieValue}; expires\x3d${a.toGMTString()}; path\x3d/; domain\x3d.edx.org;`;
}

export function getCookies() {
  const cookies = document.cookie.split(';');
  const cookieObj = {};

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const parts = cookie.split('=');
    const key = parts[0];
    const value = parts.slice(1).join('=');
    try {
      cookieObj[key] = decodeURIComponent(value);
    } catch (e) {
      cookieObj[key] = value;
    }
  }
  return cookieObj;
}

export const handleCorrelationIDCookie = () => {
  // set correlation ID to a random UUID
  const correlationId = window.crypto.randomUUID();

  setCookie('tglr_correlation_id', correlationId);
  return correlationId;
};
